<!-- 人工叫料材料报表 -->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form class="search-form-material" ref="lsSearchForm" @search="onSearch" @reset="resetQuery" :formList="formList">
        <global-select
          slot="organizationName"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.organizationName"
          :selectData="inventOrg"
          :selectItem="{ value: 'label', label: 'label' }"
        />
        <a-switch slot="unallocatedMaterialsFlg" v-model="queryParams.unallocatedMaterialsFlg" />
        <a-switch slot="unreleasedMaterialsFlg" v-model="queryParams.unreleasedMaterialsFlg" />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiInvCallRequestLinesNewExport" ref="download" />
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MANUAL_CALL_MATERIAL_LIST, // 表格方案配置唯一值
              }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetManualMaterialReport, apiInvCallRequestLinesNewExport } from '@/api/report/manual-call-material'
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import moment from 'moment'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Manual-call-material', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  mixins: [cacheSearch],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data() {
    return {
      apiInvCallRequestLinesNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetManualMaterialReport, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        supplierId: undefined,
        tenantId: undefined,
        skuKey: undefined,
        skuName: undefined,
        attr03: '0',
        attr09: undefined,
        lotKey: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '加工商',
          decorator: ['organizationName'],
          type: 'organizationName'
        },
        {
          label: '物料编码',
          decorator: ['itemCode'],
          type: 'input'
        },
        {
          label: '创建时间',
          type: 'range',
          decorator: ['demandDate'],
          disposeFormat: {
            staCreateTime: (change) => {
              return change[0].format('YYYY-MM-DD 00:00:00')
            },
            endCreateTime: (change) => {
              return change[1].format('YYYY-MM-DD 23:59:59')
            }
          }
        },
        {
          label: '仅查询未分配物料',
          decorator: ['unallocatedMaterialsFlg'],
          type: 'unallocatedMaterialsFlg',
          lableCol: {
            xs: { span: 24 },
            sm: { span: 6 }
          }
        },
        {
          label: '仅查询未发料物料',
          decorator: ['unreleasedMaterialsFlg'],
          type: 'unreleasedMaterialsFlg'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '加工商',
          dataIndex: 'organizationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '叫料单号',
          dataIndex: 'callMaterialNumber',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '发货单号',
          dataIndex: 'wmsNumbers',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'uom',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '需求时间',
          dataIndex: 'requestShipmentDate',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '最早发货时间',
          dataIndex: 'earliestDeliveryTime',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '实际发货数量',
          dataIndex: 'actualDeliveryQuantity',
          align: 'center',
          width: 140,
          ellipsis: true
        },
        {
          title: '最后接收时间',
          dataIndex: 'lastReceivedTime',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '已接收数量',
          dataIndex: 'receivedQuantity',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '未发数量',
          dataIndex: 'unpaidQuantity',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '未分配数量',
          dataIndex: 'unallocatedAmount',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '在途数量',
          dataIndex: 'inTransitQuantity',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '库存可用量',
          dataIndex: 'availableQuantity',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '备注',
          dataIndex: 'notes',
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  created() {
    // 处理缓存逻辑
    if (this.cacheHistory && this.cacheHistory[this.$route?.fullPath]) {
      this.getHistoryCache('lsSearchForm', '', { demandDate: ['staCreateTime', 'endCreateTime'] })
      this.$nextTick(() => {
        this.onSearch()
      })
    } else {
      this.$nextTick(() => {
        const tempSearchForm = this.$refs.lsSearchForm
        tempSearchForm.form.setFieldsValue({
          demandDate: [ moment().subtract(6, 'days'), moment() ]
        })
        this.onSearch(
          {
            staCreateTime: moment().subtract(6, 'days').format('YYYY-MM-DD 23:59:59'),
            endCreateTime: moment().format('YYYY-MM-DD 00:00:00')
          }
        )
      })
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   const tempSearchForm = this.$refs.lsSearchForm
    //   tempSearchForm.layout = {
    //     "labelCol": {
    //         "style": "width: 150px"
    //     },
    //     "wrapperCol": {
    //         "style": "width:calc(100% - 150px );max-width:280px"
    //     }
    //   }
    //   tempSearchForm.form.setFieldsValue({
    //     demandDate: [ moment().subtract(6, 'days'), moment() ]
    //   })
    //   this.onSearch(
    //     {
    //       staCreateTime: moment().subtract(6, 'days').format('YYYY-MM-DD 23:59:59'),
    //       endCreateTime: moment().format('YYYY-MM-DD 00:00:00')
    //     }
    //   )
    // })
    //
    // 获取当天日期
    // const todayDate = moment();
    // 往后推7天的日期
    // const nextWeekDate = moment().add(7, 'days');
  },
  methods: {
    // 表单搜索
    onSearch(value = {}) {
      console.log(value)
      const params = {
        ...this.queryParams,
        ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      if (params.attr03.toString() === '0') {
        delete params.attr03
      }
      params.unallocatedMaterialsFlg = params.unallocatedMaterialsFlg ? 'Y' : undefined
      params.unreleasedMaterialsFlg = params.unreleasedMaterialsFlg ? 'Y' : undefined
      this.$refs.dataTable.searchParams = params
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        organizationCode: undefined,
        tenantId: undefined,
        skuKey: undefined,
        skuName: undefined,
        attr03: '0',
        attr09: undefined,
        lotKey: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
      // this.download(
      //   '/inv/invCallRequestLines/exportManualMaterialReport',
      //   this.$refs.dataTable.searchParams,
      //   `人工叫料材料报表_${new Date().getTime()}.xlsx`
      // )
    }
  }
}
</script>

<style scoped lang="less">
/deep/.search-form-material {
  .ant-form-item{
    .ant-form-item-label{
      width: 150px !important;
    }
  }
}
</style>
